﻿import TKSearch from '@tk/controls/tk.search';
import { directSearchSuggestMessages } from '@tk/utilities/tk.messages';

export default class KWSearch extends TKSearch {
    setMessageTooShort(): void {
        const msgTpl: string = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${directSearchSuggestMessages.messageTooShort.text.replace('%1', String(this.directSearchMinLength))}
            </span>
        </div>`;

        this.directSearchResult!.insertAdjacentHTML('beforeend', msgTpl);
        this.directSearchResult!.style.gap = '0';
    }
}